import { type ReactNode } from 'react';
import { createRoot } from 'react-dom/client';
import { flushSync } from 'react-dom';

/**
 * Render a React node into a DOM element handed to CodeMirror (tooltips,
 * completion icons, info panels).
 *
 * CodeMirror invokes these render callbacks synchronously, possibly while an
 * editor update is in progress. Calling flushSync at that point forces React
 * to flush pending passive effects mid-update; if any of them dispatch into
 * an editor (e.g. the value-sync effect in use-code-mirror), CodeMirror
 * throws "Calls to EditorView.update are not allowed while an update is in
 * progress". Deferring to a microtask lets the current update finish first;
 * the flushSync inside it still commits the content before CodeMirror
 * measures and positions the element in the next animation frame.
 */
export const renderIntoCodeMirrorElement = (element: HTMLElement, node: ReactNode) => {
  queueMicrotask(() => flushSync(() => createRoot(element).render(node)));
};
